// @todo use standart server response from server. do not use this collection.
define('lib/collection/PaginatedCollection',['require','lib/collection/BaseCollection'],function (require) {
    var BaseCollection = require('lib/collection/BaseCollection');

    return BaseCollection.extend({

        options : {},
        perPage : 10,
        page : 1,

        initialize: function() {
            BaseCollection.prototype.initialize.call(this);
        },

        fetch: function(options) {
            this.makeUrl();
            if(typeof(options) === 'undefined'){
                options = {}
            }
            this.trigger("fetching");
            var self = this;
            var success = options.success;
            options.success = function(resp) {
                self.trigger("fetched");
                if(success) { success(self, resp); }
            };
            return Backbone.Collection.prototype.fetch.call(this, options);
        },

        parse: function(resp) {
            this.page = resp.page;
            this.perPage = resp.perPage;
            this.total = resp.total;
            return resp.models;
        },

        makeUrl: function() {
            this.url =  this.baseUrl + '?' + jQuery.param({page: this.page, perPage: this.perPage});
        },

        pageInfo: function() {
            var tPages = 1;
            if(this.perPage) {
                tPages = Math.ceil(this.total / this.perPage);
            }

            var info = {
                total: this.total,
                page: this.page,
                perPage: this.perPage,
                pages: tPages,
                prev: false,
                next: false
            };

            var max = this.total;

            if(this.perPage) {
                max = Math.min(this.total, this.page * this.perPage);
                if (this.total === this.pages * this.perPage) {
                    max = this.total;
                }
            }

            info.range = [0, max];
            if(this.perPage) {
                info.range = [(this.page - 1) * this.perPage + 1, max];
            }

            if (this.page > 1) {
                info.prev = this.page - 1;
            }

            if (this.page < info.pages) {
                info.next = this.page + 1;
            }

            info.p_page = info.pages-1;

            return info;
        },

        nextPage: function() {
            if (!this.pageInfo().next) {
                return false;
            }
            this.page = this.page + 1;
            return this.fetch();
        },

        previousPage: function() {
            if (!this.pageInfo().prev) {
                return false;
            }
            this.page = this.page - 1;
            return this.fetch();
        },

        reloadPage : function () {
            return this.fetch();
        }

    });
});
